import axios from 'axios';
import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';
import { CustomFilters } from '../types/types.system';
import { useAppSelector } from '../contexts/hooks';

export const useApiInformedConsents = () => {
  const { runApi, runApiFormData } = useApi();
  const token = useAppSelector((x) => x.userInfo.Token);
  const apiUrlFromRedux = useAppSelector((x) => x.configuration.apiUrl);

  // Obtener configuración / listado con filtros
  const getData = async (filters: CustomFilters[]) => {
    return runApi('InformedConsents/getData', 'POST', null, filters).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  // Create
  const createConsent = async (data: any) => {
    const res = await runApi('InformedConsents/CreateConsentimiento', 'POST', null, data);
    if (res.internalCode >= 200) {
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // Get all
  const getConsents = async () => {
    const res = await runApi('InformedConsents/GetConsentimientos', 'GET', null, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return [];
    }
    return res.data;
  };

  // Update
  const updateConsent = async (data: any) => {
    const res = await runApi('InformedConsents/UpdateConsentimiento', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // Delete
  const deleteConsent = async (id: number) => {
    // backend controller uses HttpDelete, but client helper only supports GET/POST so we call POST here as other APIs do
    const res = await runApi('InformedConsents/DeleteConsentimiento', 'POST', { id }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return false;
    }
    newToast('SUCCESS', res.message, 3);
    return true;
  };

  // Sign document (file upload + metadata via form)
  // file: File, data: object -> UploadConsentFileRequest
  const signDocument = async (data: any) => {    
    const res = await runApi('InformedConsents/SignDocument', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

    const SignDocumentAutorize = async (data: any) => {    
    const res = await runApi('InformedConsents/SignDocumentAutorize', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // Fill format (create filled format)
  const fillFormat = async (data: any) => {
    const res = await runApi('InformedConsents/FillFormat', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // Get by order id
  const getConsentByIdOrder = async (IdOrden: number) => {
    const res = await runApi('InformedConsents/GetConsentimientoByIdOrder', 'GET', { IdOrden }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    return res.data;
  };

  // PutSended: type, idOrder, IdCst
  const putSended = async (type: any, idOrder: number, IdCst: number) => {
    const res = await runApi('InformedConsents/PutSended', 'POST', null, { type, idOrder, IdCst });
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return false;
    }
    newToast('SUCCESS', res.message, 3);
    return true;
  };

  // UpdateFormat
  const updateFormat = async (data: any) => {
    const res = await runApi('InformedConsents/UpdateFormat', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // CreateConsentimientoByOrder
  const CreateConsentimientoByOrder = async (data: any) => {
    const res = await runApi('InformedConsents/CreateConsentimientoByOrder', 'POST', data, null);
    if (res.internalCode >= 200) {
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // Consentimientos recibidos de otros laboratorios (importados por referencia vía el hub)
  const getConsentimientosImportados = async (IdOrden: number) => {
    const res = await runApi('InformedConsents/GetConsentimientosImportados', 'GET', { IdOrden }, null);
    if (res.internalCode >= 200) {
      return [];
    }
    return res.data;
  };

  // URL temporal del PDF de un consentimiento importado (el PDF vive en el hub)
  const getConsentimientoImportadoPdf = async (ConsentUuid: string) => {
    const res = await runApi('InformedConsents/GetConsentimientoImportadoPdf', 'GET', { ConsentUuid }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    return res.data?.pdfUrl ?? null;
  };

  // Envía al paciente la notificación (correo/WhatsApp) con el enlace para diligenciar/firmar.
  // medio: undefined = todos los medios habilitados; 1 = Correo; 2 = WhatsApp.
  const enviarParaFirma = async (idOrden: number, medio?: number) => {
    const res = await runApi('InformedConsents/SendForSignature', 'POST', { IdOrden: idOrden, medio }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return false;
    }
    newToast('SUCCESS', 'Notificación enviada al paciente.', 4);
    return true;
  };

  // Busca en el hub consentimientos otorgados a este laboratorio (importación manual de respaldo)
  const buscarConsentimientosHub = async (Documento?: string) => {
    const res = await runApi('InformedConsents/BuscarConsentimientosHub', 'GET', { Documento }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return [];
    }
    return res.data;
  };

  // Importa manualmente un consentimiento del hub a una orden local
  const importarConsentimientoHub = async (IdOrden: number, ConsentUuid: string) => {
    const res = await runApi('InformedConsents/ImportarConsentimientoHub', 'POST', { IdOrden, ConsentUuid }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return false;
    }
    newToast('SUCCESS', res.message, 3);
    return true;
  };

  // Búsqueda masiva de consentimientos (módulo Consentimientos informados): por documento, fechas y estado.
  const buscarConsentimientosMasivo = async (filtro: any) => {
    const res = await runApi('InformedConsents/BuscarConsentimientosMasivo', 'POST', null, filtro);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return [];
    }
    return res.data;
  };

  // Descarga el PDF de un consentimiento firmado (server-side) y lo baja como archivo.
  const descargarConsentimientoPdf = async (idOrden: number, idCst: number, fileName?: string) => {
    try {
      let base = apiUrlFromRedux;
      if (!base) {
        const cfg = await (await fetch('/config.json')).json();
        base = cfg.apiUrl;
      }
      const res = await axios.get(`${base}/api/InformedConsents/GenerateConsentPdf`, {
        params: { IdOrden: idOrden, IdCst: idCst },
        headers: { Authorization: token },
        responseType: 'blob',
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName || `Consentimiento-Ord${idOrden}-Cst${idCst}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      return true;
    } catch (err) {
      newToast('ERROR', 'No fue posible descargar el PDF del consentimiento.', 5);
      return false;
    }
  };

  return {
    getData,
    createConsent,
    getConsents,
    updateConsent,
    deleteConsent,
    signDocument,
    SignDocumentAutorize,
    fillFormat,
    getConsentByIdOrder,
    putSended,
    updateFormat,
    CreateConsentimientoByOrder,
    getConsentimientosImportados,
    getConsentimientoImportadoPdf,
    buscarConsentimientosHub,
    importarConsentimientoHub,
    buscarConsentimientosMasivo,
    descargarConsentimientoPdf,
    enviarParaFirma,
  };
};
